import moment from "moment/moment";

export function parseToISODate(timestamp) {
	return timestamp?.toDate()?.toLocaleDateString("sv") || "";
}

export function formatDate(date, format = "YYYY-MM-DD") {
	return date && moment(date.toDate?.() || date).format(format);
}
